<script setup>
    import { LockClosedIcon } from '@heroicons/vue/24/outline'
</script>

<template>
    <LockClosedIcon />
</template>
